/* Bocetta v1.1 · Se siente como app. Script clásico, sin dependencias.
   - Barra de pestañas: Buscar abre el buscador de Horizon y Carrito su cajón; el globo sigue al carrito.
   - Encabezado: marca html.bc-scroll al bajar.
   - Teclado abierto: la barra se aparta (html.bc-teclado).
   - Animaciones decorativas (bandera, arcoíris, insignia): se pausan fuera de la vista.
   - Precarga: al pasar el dedo o el mouse por un enlace, la página siguiente se baja antes del clic. */
(() => {
  const html = document.documentElement;
  const tabs = document.querySelector('[data-bc-tabs]');
  if (tabs) html.classList.add('bc-con-tabs');

  /* ---------- Pestañas ---------- */
  if (tabs) {
    tabs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-bc-accion]');
      if (!b) return;
      const accion = b.dataset.bcAccion;
      const disparador = accion === 'buscar'
        ? document.querySelector('#header-component search-button button, search-button button')
        : document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (disparador) {
        e.preventDefault();
        disparador.click();
        if (navigator.vibrate) try { navigator.vibrate(6); } catch (_) {}
      }
      // Sin buscador o cajón (p. ej. carrito como página): el enlace sigue su camino normal
    });

    // Globo del carrito: copia el número del ícono de Horizon cada vez que cambia
    const globo = tabs.querySelector('[data-bc-globo]');
    const fuente = () => document.querySelector('.header-actions__cart-icon .cart-bubble__text-count, [data-testid="cart-bubble"]');
    let previo = globo ? Number(globo.textContent) || 0 : 0;
    const copiar = () => {
      const f = fuente();
      if (!f || !globo) return;
      const n = parseInt(f.textContent, 10) || 0;
      globo.textContent = n > 99 ? '99+' : String(n);
      globo.hidden = n === 0;
      if (n > previo) { globo.classList.remove('bc-brinca'); void globo.offsetWidth; globo.classList.add('bc-brinca'); }
      previo = n;
    };
    const vigilarGlobo = () => {
      const f = fuente();
      if (!f) return false;
      new MutationObserver(copiar).observe(f, { childList: true, characterData: true, subtree: true });
      copiar();
      return true;
    };
    if (!vigilarGlobo()) document.addEventListener('DOMContentLoaded', vigilarGlobo, { once: true });
    document.addEventListener('shopify:cart:lines-update', (e) => {
      const fin = e && e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve();
      fin.then(() => setTimeout(copiar, 60), () => {});
    });

    // Teclado en pantalla: la barra se aparta mientras se escribe
    const esCampo = (el) => el instanceof HTMLElement && (el.isContentEditable || (el.matches('input, textarea, select') && !el.matches('[type="checkbox"], [type="radio"], [type="button"], [type="submit"], [type="range"]')));
    document.addEventListener('focusin', (e) => { if (esCampo(e.target)) html.classList.add('bc-teclado'); });
    document.addEventListener('focusout', () => setTimeout(() => { if (!esCampo(document.activeElement)) html.classList.remove('bc-teclado'); }, 60));
  }

  /* ---------- Encabezado al bajar ----------
     En compu (990 px o más) Horizon desplaza .page-wrapper en lugar de la ventana: se escucha el scroll de ambos. */
  let bajando = false;
  const desplazado = () => Math.max(window.scrollY || 0, document.querySelector('.page-wrapper')?.scrollTop || 0);
  const marcarScroll = () => {
    bajando = false;
    html.classList.toggle('bc-scroll', desplazado() > 8);
  };
  document.addEventListener('scroll', () => { if (!bajando) { bajando = true; requestAnimationFrame(marcarScroll); } }, { passive: true, capture: true });
  marcarScroll();

  /* ---------- Pestaña oculta: todo en pausa ---------- */
  document.addEventListener('visibilitychange', () => html.classList.toggle('bc-oculta', document.hidden));

  /* ---------- Animaciones decorativas: solo corren cuando se ven ---------- */
  const DECORATIVAS = '.announcement-bar, .bc-arcoiris, .bc-enlace-arcoiris, .bc-boton-arcoiris, .insignia, .bc-barra__avance';
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entradas) => {
      for (const e of entradas) e.target.toggleAttribute('data-bc-fuera', !e.isIntersecting);
    }, { rootMargin: '80px 0px' });
    const vistos = new WeakSet();
    const observar = (raiz = document) => {
      raiz.querySelectorAll?.(DECORATIVAS).forEach((el) => { if (!vistos.has(el)) { vistos.add(el); io.observe(el); } });
    };
    observar();
    document.addEventListener('DOMContentLoaded', () => observar());
    // Secciones que Horizon vuelve a pintar (carrito, editor): se observan sus piezas nuevas
    let espera = 0;
    new MutationObserver(() => { clearTimeout(espera); espera = setTimeout(() => observar(), 200); })
      .observe(document.body || html, { childList: true, subtree: true });
  }

  /* ---------- Precarga de páginas ---------- */
  // Navegadores con Speculation Rules ya lo hacen con las reglas del <head>. Aquí, el respaldo para Safari y Firefox:
  // al tocar o pasar por un enlace interno, se pide la página para que el clic abra al instante.
  const conReglas = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  const conexion = navigator.connection;
  const ahorro = conexion && (conexion.saveData || /(^|-)2g$/.test(conexion.effectiveType || ''));
  if (!conReglas && !ahorro) {
    const pedidas = new Set();
    const NO = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account|search|apps|tools|services|admin)(?:\/|$|\?)/i;
    const precargar = (a) => {
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.dataset.noPrerender !== undefined) return;
      let url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || NO.test(url.pathname) || url.hash && url.pathname === location.pathname) return;
      url.hash = '';
      const clave = url.href;
      if (pedidas.has(clave) || clave === location.href.split('#')[0]) return;
      pedidas.add(clave);
      const l = document.createElement('link');
      l.rel = 'prefetch'; l.href = clave; l.as = 'document';
      document.head.appendChild(l);
    };
    let temporizador = 0;
    document.addEventListener('pointerover', (e) => {
      const a = e.target.closest?.('a[href]');
      clearTimeout(temporizador);
      if (a) temporizador = setTimeout(() => precargar(a), 80);
    }, { passive: true });
    document.addEventListener('touchstart', (e) => precargar(e.target.closest?.('a[href]')), { passive: true });
    document.addEventListener('focusin', (e) => { if (e.target.matches?.('a[href]')) precargar(e.target); });
  }
})();

/* ---------- v1.1 · Escenas del inicio: transiciones con el scroll ----------
   Hero → foto (Horizon «hero» de pantalla completa) → sección siguiente. Se ubican solas por su orden en la
   página, así que siguen funcionando si se mueven o cambian las secciones desde el editor. */
(() => {
  const html = document.documentElement;
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.template !== 'index') return;
  if (html.classList.contains('shopify-design-mode')) return; // en el editor todo queda quieto para editar cómodo
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const visibles = () => [...main.children].filter((s) => s.classList.contains('shopify-section') && s.offsetHeight > 0);
  const secciones = visibles();
  const foto = secciones.find((s) => s.classList.contains('hero-wrapper'));
  if (!foto) return;
  const i = secciones.indexOf(foto);
  const hero = secciones[i - 1] || null;
  const cortina = secciones[i + 1] || null;

  html.classList.add('bc-escenas');
  foto.classList.add('bc-escena-foto');
  hero?.classList.add('bc-escena-hero');
  cortina?.classList.add('bc-escena-cortina');

  const limitar = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const suave = (t) => 1 - Math.pow(1 - t, 3);
  let pendiente = false;
  let antes = {};
  const poner = (el, k, v) => {
    const clave = k + (el === foto ? 'f' : el === hero ? 'h' : 'c');
    const txt = v.toFixed(4);
    if (antes[clave] === txt) return;
    antes[clave] = txt;
    el.style.setProperty(k, txt);
  };

  // Dónde queda la foto sin scroll: si ya se asoma al cargar, la entrada cuenta desde ahí (empieza en 0, no a medias)
  const desplazado = () => Math.max(window.scrollY || 0, document.querySelector('.page-wrapper')?.scrollTop || 0);
  let reposo = foto.getBoundingClientRect().top + desplazado();
  window.addEventListener('resize', () => { reposo = foto.getBoundingClientRect().top + desplazado(); });

  function cuadro() {
    pendiente = false;
    const V = window.innerHeight;
    const rf = foto.getBoundingClientRect();
    // Entrada de la foto: de su lugar inicial (o de asomarse abajo) a llegar arriba
    const desde = Math.max(1, Math.min(V * 0.9, reposo));
    const entra = suave(limitar((desde - rf.top) / desde));
    poner(foto, '--bc-in', entra);
    if (hero) poner(hero, '--bc-in', entra);
    // La hoja de abajo cubre la foto
    if (cortina) {
      const rc = cortina.getBoundingClientRect();
      const base = Math.min(rf.bottom, V);
      const cubre = limitar((base - rc.top) / Math.max(1, Math.min(rf.height, V)));
      poner(foto, '--bc-out', cubre);
      poner(cortina, '--bc-cov', cubre);
      foto.classList.toggle('bc-tapada', cubre >= 0.999);
    }
  }
  const pedir = () => { if (!pendiente) { pendiente = true; requestAnimationFrame(cuadro); } };
  // capture: también llega el scroll de .page-wrapper, que es lo que se desplaza en compu
  document.addEventListener('scroll', pedir, { passive: true, capture: true });
  window.addEventListener('resize', pedir);
  cuadro();

  // Cascada: las piezas de las secciones de abajo aparecen al entrar en pantalla
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entradas) => {
    for (const e of entradas) {
      if (!e.isIntersecting) continue;
      e.target.classList.add('bc-visto');
      io.unobserve(e.target);
    }
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  const V0 = window.innerHeight;
  secciones.slice(i + 1).forEach((s) => {
    const piezas = [
      ...s.querySelectorAll('.section-content-wrapper > :not(.group-block):not(style):not(script)'),
      ...s.querySelectorAll('.group-block-content > :not(style):not(script)')
    ];
    let n = 0;
    piezas.forEach((p) => {
      if (p.getBoundingClientRect().top < V0) return; // lo que ya se ve no se esconde
      p.classList.add('bc-revela');
      p.style.setProperty('--bc-i', String(n++ % 4));
      io.observe(p);
    });
  });
})();

/* ---------- v1.1 · Precios en México con «MXN» ----------
   En México los precios llevan «MXN» para que nadie los confunda con dólares; en Europa se ven en € y en el resto en $ (USD),
   que ya se distinguen solos. El Liquid ya lo escribe en la mayoría de los precios; esto cubre los que pinta el JS del tema
   (carrito, búsqueda, tarjetas) y los que llegan después por fetch. */
(() => {
  const B = window.BOCETTA || {};
  const moneda = B.moneda || (window.Shopify && Shopify.currency && Shopify.currency.active);
  if (moneda !== 'MXN') return;
  const PRECIO = /(\$\s?\d[\d,]*(?:\.\d{1,2})?)(?![\d,.]|\s*MXN)/g;
  const SALTAR = 'script,style,textarea,input,select,option,noscript,[contenteditable],.rte';
  function marcar(nodo) {
    const el = nodo.parentElement;
    const t = nodo.nodeValue;
    if (!el || !t || t.indexOf('$') < 0 || el.closest(SALTAR)) return;
    if (/MXN/.test((el.parentElement || el).textContent)) return;
    const nuevo = t.replace(PRECIO, '$1 MXN');
    if (nuevo !== t) nodo.nodeValue = nuevo;
  }
  function recorrer(raiz) {
    if (raiz.nodeType === 3) return marcar(raiz);
    if (raiz.nodeType !== 1) return;
    const w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = w.nextNode())) marcar(n);
  }
  let pendientes = new Set();
  let programado = false;
  function procesar() {
    programado = false;
    const lote = pendientes;
    pendientes = new Set();
    lote.forEach((n) => n.isConnected && recorrer(n));
  }
  const mo = new MutationObserver((cambios) => {
    for (const c of cambios) {
      if (c.type === 'characterData') pendientes.add(c.target);
      else c.addedNodes.forEach((n) => pendientes.add(n));
    }
    if (!programado && pendientes.size) { programado = true; requestAnimationFrame(procesar); }
  });
  const iniciar = () => {
    recorrer(document.body);
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  else iniciar();
})();

/* ---------- v1.1 · Palabras que cambian de color en los títulos del editor ----------
   Los títulos de algunas plantillas viven en el editor de temas (y su traducción al español aparte), así que la palabra
   clave se pinta aquí, en los dos idiomas, sin tocar las traducciones. Los nombres de color van en su color. */
(() => {
  const CLAVES = {
    'Pick your paper.': 'paper', 'Elige tu papel.': 'papel',
    'Notebooks for teams that make things.': 'make things', 'Libretas para equipos que crean cosas.': 'crean cosas',
    'Find your color.': 'color', 'Encuentra tu color.': 'color'
  };
  const COLORES = /\b(Nero|Blu|Rosso|Viola)\b/g;
  function pintar(raiz = document) {
    raiz.querySelectorAll('.text-block h1, .text-block h2').forEach((h) => {
      if (h.dataset.bcPintado) return;
      const clave = CLAVES[h.textContent.trim()];
      if (!clave || h.children.length) return;
      const i = h.textContent.lastIndexOf(clave);
      const t = h.textContent;
      h.textContent = '';
      h.append(t.slice(0, i));
      const s = document.createElement('span');
      s.className = 'bc-arcoiris bc-arcoiris--titulo';
      s.textContent = clave;
      h.append(s, t.slice(i + clave.length));
      h.dataset.bcPintado = '1';
    });
    raiz.querySelectorAll('.text-block p').forEach((p) => {
      if (p.dataset.bcPintado || p.querySelector('.bc-color') || !COLORES.test(p.textContent)) return;
      COLORES.lastIndex = 0;
      const w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
      const nodos = [];
      let n;
      while ((n = w.nextNode())) nodos.push(n);
      nodos.forEach((nodo) => {
        const partes = nodo.nodeValue.split(COLORES);
        if (partes.length < 2) return;
        const frag = document.createDocumentFragment();
        partes.forEach((parte, k) => {
          if (k % 2) {
            const s = document.createElement('strong');
            s.className = 'bc-color bc-color--' + parte.toLowerCase();
            s.textContent = parte;
            frag.append(s);
          } else if (parte) frag.append(parte);
        });
        nodo.replaceWith(frag);
      });
      p.dataset.bcPintado = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => pintar(), { once: true });
  else pintar();
})();
